import { render, staticRenderFns } from "./ServiceNotificationsBlock.vue?vue&type=template&id=051abd48&scoped=true"
import script from "./ServiceNotificationsBlock.vue?vue&type=script&lang=js"
export * from "./ServiceNotificationsBlock.vue?vue&type=script&lang=js"
import style0 from "./ServiceNotificationsBlock.vue?vue&type=style&index=0&id=051abd48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051abd48",
  null
  
)

export default component.exports